import { get } from 'lodash';

import { trackEmailInUseError } from './tracking';

export const CREATE_ACCOUNT_START = '@@createaccountform/CREATE_ACCOUNT_START';
export const CREATE_ACCOUNT_SUCCESS =
    '@@createaccountform/CREATE_ACCOUNT_SUCCESS';
export const CREATE_ACCOUNT_FIELD_ERROR =
    '@@createaccountform/CREATE_ACCOUNT_FIELD_ERROR';
export const CREATE_ACCOUNT_FAILURE =
    '@@createaccountform/CREATE_ACCOUNT_FAILURE';
export const CLEAR_EMAIL_ERROR = '@@createaccountform/CLEAR_EMAIL_ERROR';

export const CREATE_ACCOUNT_PRE_SUBMIT = 'CREATE_ACCOUNT_FORM_SUBMIT';
export const CREATE_ACCOUNT_FORM_MODIFIED = 'CREATE_ACCOUNT_FORM_MODIFIED';
export const CREATE_ACCOUNT_VALIDATION_ERROR =
    'CREATE_ACCOUNT_VALIDATION_ERROR';

export const CreateAccountActions = {
    CLEAR_EMAIL_ERROR,
    CREATE_ACCOUNT_START,
    CREATE_ACCOUNT_SUCCESS,
    CREATE_ACCOUNT_FIELD_ERROR,
    CREATE_ACCOUNT_FAILURE,
    CREATE_ACCOUNT_PRE_SUBMIT,
    CREATE_ACCOUNT_FORM_MODIFIED,
    CREATE_ACCOUNT_VALIDATION_ERROR,
};

const apiHost = process.env.API_HOST || '';
const standardEndpoint = `${apiHost}/api/web/2/patient`;
const socialLoginEndpoint = `${apiHost}/api/web/2/patient/sociallogin`;

export const clearEmailError = () => ({
    type: CreateAccountActions.CLEAR_EMAIL_ERROR,
});

export const createAccountStart = () => ({
    type: CreateAccountActions.CREATE_ACCOUNT_START,
});

export const createAccountPreSubmit = () => ({
    type: CreateAccountActions.CREATE_ACCOUNT_PRE_SUBMIT,
});

export const createAccountModified = (field, value) => ({
    type: CreateAccountActions.CREATE_ACCOUNT_FORM_MODIFIED,
    field,
    value,
});

export const createAccountValidationError = (field, value) => ({
    type: CreateAccountActions.CREATE_ACCOUNT_VALIDATION_ERROR,
    field,
    value,
});
export const createAccountSuccess = (
    email,
    password,
    rememberMe,
    responseBody
) => ({
    type: CreateAccountActions.CREATE_ACCOUNT_SUCCESS,
    responseBody,
    email,
    password,
    rememberMe,
});

export const createAccountFieldError = responseBody => ({
    type: CreateAccountActions.CREATE_ACCOUNT_FIELD_ERROR,
    responseBody,
});

export const createAccountFailure = () => ({
    type: CreateAccountActions.CREATE_ACCOUNT_FAILURE,
});

export function createAccountFetch(user) {
    let endpoint;
    const requestBody = {
        accepted_hipaa_authorization: user.hipaaAuth,
        accepted_terms_of_use: user.termsOfUse,
        date_of_birth: user.dateOfBirth,
        email: user.email,
        first_name: user.firstName,
        gender: user.gender,
        last_name: user.lastName,
        remember_me: user.rememberMe,
    };

    if (user.isSocialAccount) {
        endpoint = socialLoginEndpoint;
        requestBody.id_token = user.userIdToken;
    } else {
        endpoint = standardEndpoint;
        requestBody.password = user.password;
    }

    return async dispatch => {
        const fetchData = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
            credentials: 'include',
        };
        let responseStatus;

        try {
            const response = await fetch(endpoint, fetchData);
            const body = await response.json();
            responseStatus = response.status;

            if (responseStatus === 201) {
                dispatch(
                    createAccountSuccess(
                        user.email,
                        user.password,
                        user.rememberMe,
                        body
                    )
                );
            } else if (responseStatus === 400) {
                if (
                    get(body, 'error.fields', []).some(
                        field => field.name === 'email'
                    )
                ) {
                    dispatch(trackEmailInUseError());
                }

                dispatch(createAccountFieldError(body.error.fields));
            } else {
                dispatch(createAccountFailure());
            }
        } catch (e) {
            dispatch(createAccountFailure());
        }
    };
}
